import $ = require("jquery");
import _ = require("underscore");
import Portal = require("portal-gis");
import Services = require("./services");
import globals = require("../../globals");

interface RowItem {
    id: number;
    data: Portal.MapApplicationElement;
    metadata: PublishedMapsMetaData;
    href: string
}

interface PublishedMapsMetaData {
    title?: string;
    description?: string;
    effectivedate?: Date;
    expireddata?: Date;
}

class PublishedMaps extends Services.BaseService<RowItem> {

    static about = `Proxy for the property/publishedmaps service.`;

    constructor(public api: Services.API) {
        super(api, "property/publishedmaps");
        this.idAttribute = "id";
    }

    post(map: { data: Portal.MapApplicationElement }, metadata?: PublishedMapsMetaData) {

        metadata = _.extend({
            title: map.data.text
        }, metadata);

        return super.post({
            metadata: JSON.stringify(metadata),
            data: JSON.stringify(map.data)
        });

    }

    put(id: number, map: { data: Portal.MapApplicationElement }, metadata?: PublishedMapsMetaData) {

        metadata = _.extend({
            title: map.data.text
        }, metadata);

        return super.put(id, {
            metadata: JSON.stringify(metadata),
            data: JSON.stringify(map.data)
        });

    }

    public each() {

        let q = this.api.query ? "?" + $.param(this.api.query) : "";

        return this.auth<Array<RowItem>>(() => $.ajax({
            dataType: "json",
            url: `${this.api.endpoint}/${this.serviceName}${q}`,
            proxy: false,
            cache: globals.cachebust !== "1"
        }));

    }

    public all(cb?: (item: RowItem) => void) {

        var d = $.Deferred<Array<RowItem>>();

        this.each().done(ids => {
            cb && ids.forEach(item => this.get(item["id"]).done(cb));
            d.resolve(ids);
        });

        return d;
    }

}

export = PublishedMaps;